import React, { useEffect, useState } from 'react';
import Editor from '@monaco-editor/react';
import { Loading, useDarkModeTheme } from '@therms/atalaya';

export const MonacoEditor = ({ language, text }) => {
  const [loading, setLoading] = useState(true);
  const [isDark] = useDarkModeTheme();

  useEffect(() => {
    // we want the editor to refresh when the `text` prop changes, so we use
    // this work-around to show loading which unmounts the editor for a few
    // miliseconds
    setLoading(true);
  }, [text]);

  useEffect(() => {
    if (loading) {
      const t = setTimeout(() => {
        setLoading(false);
      }, 500);

      return () => clearTimeout(t);
    }
  }, [loading]);

  if (loading) {
    return <Loading message='Loading JSON-schema...' overlay size='2xl' />;
  }

  return (
    <div>
      <Editor
        options={{
          automaticLayout: true,
          lineNumbers: false,
          readOnly: true,
          rulers: false,
        }}
        height="500px"
        language={language}
        theme={isDark ? 'vs-dark' : 'light'}
        value={text}
      />
    </div>
  );
};
